module.exports = {
  text: {
    defaultInput: '',
    fileExt: '.txt',
    indent: null, // 沒實作
  },

  json: {
    defaultInput: '{\n\n}',
    fileExt: '.json',
    indent: {
      default: 4,
      supportTab: true,
    },
  },

  yaml: {
    defaultInput: '',
    fileExt: '.yaml',
    indent: {
      default: 4,
      supportTab: false,
    },
  },

  toml: {
    defaultInput: '',
    fileExt: '.toml',
    indent: null,
  },

  xml: {
    defaultInput: '',
    fileExt: '.xml',
    indent: {
      default: 4,
      supportTab: false,
    },
  },

  html: {
    defaultInput: '',
    fileExt: '.html',
    indent: {
      default: 4,
      supportTab: true,
    },
  },

  js: {
    defaultInput: '',
    fileExt: '.js',
    indent: {
      default: 2,
      supportTab: true,
    },
  },

  css: {
    defaultInput: '',
    fileExt: '.css',
    indent: {
      default: 4,
      supportTab: false,
    },
  },

  sql: {
    defaultInput: '',
    fileExt: '.sql',
    indent: {
      default: 4,
      supportTab: true,
    },
  },

  python: {
    defaultInput: '',
    fileExt: '.py',
    indent: null, // 沒實作
  }
}
